/** Event facts shown on the home page, in the footer and in the contact popup. Edit here only. */
export const EVENT = {
  date: "31. 10. 2026",
  time: "15:00 – 20:00",
  faculty: "Fakulta aplikované informatiky",
  university: "Univerzita Tomáše Bati",
  address: "Nad Stráněmi 4511, 760 05 Zlín 5",
  phone: "+420 731 076 014",
  email: "m_malinakova@utb.cz",
  admission: "Zdarma",
  admissionNote: "/ dobrovolné vstupné na ofrendu",
};

export const BRAND_NAME = "UTB Fakulta La Muerte";

/** Registration opens at this moment (Europe/Prague). The backend enforces it; this copy only drives the countdown. */
export const REGISTRATION_OPENS_AT = "2026-10-10T12:00:00+02:00";
export const REGISTRATION_OPENS_LABEL = "10. 10. 2026 ve 12:00";
